import React, { useEffect, useState } from 'react';
import { Loading } from 'react-style-guide';
import { withTranslations, WithTranslationsProps } from 'react-utilities';
import { carouselTranslationConfig } from '../translation.config';
import { TCarouselItem, TAssetType } from '../types/carouselTypes';
import CarouselComponent from '../components/Carousel';
import metadataConstants from '../constants/metadataConstants';
import carouselService from '../services/carouselService';

export const Carousel = ({ translate }: WithTranslationsProps): JSX.Element => {
  const { universeId = '', placeId = '' } = metadataConstants.metadataData();
  const [assets, setAssets] = useState<TCarouselItem[] | undefined>(undefined);

  useEffect(() => {
    const fetchAssets = async () => {
      try {
        const carouselItems = await carouselService.getUniverseAssetIds(universeId);
        setAssets(carouselItems);
      } catch {
        setAssets([]);
      }
    };

    // eslint-disable-next-line no-void
    void fetchAssets();
  }, [universeId]);

  if (assets === undefined) {
    return <Loading />;
  }
  if (assets.length === 0) {
    return (
      <CarouselComponent
        translate={translate}
        items={[
          {
            type: TAssetType.Image,
            assetId: parseInt(placeId, 10)
          }
        ]}
      />
    );
  }
  return <CarouselComponent translate={translate} items={assets} />;
};

export default withTranslations(Carousel, carouselTranslationConfig);
